/** VERSION: 0.0.2 Please do not delete this line. Thank you! **/
if(typeof lazySizes !== 'function'){
	/*! lazysizes - v4.1.8 */
	!function (a, b) { var c = b(a, a.document); a.lazySizes = c, "object" == typeof module && module.exports && (module.exports = c) }(window, function (a, b) { "use strict"; if (b.getElementsByClassName) { var c, d, e = b.documentElement, f = a.Date, g = a.HTMLPictureElement, h = "addEventListener", i = "getAttribute", j = a[h], k = a.setTimeout, l = a.requestAnimationFrame || k, m = a.requestIdleCallback, n = /^picture$/i, o = ["load", "error", "lazyincluded", "_lazyloaded"], p = {}, q = Array.prototype.forEach, r = function (a, b) { return p[b] || (p[b] = new RegExp("(\\s|^)" + b + "(\\s|$)")), p[b].test(a[i]("class") || "") && p[b] }, s = function (a, b) { r(a, b) || a.setAttribute("class", (a[i]("class") || "").trim() + " " + b) }, t = function (a, b) { var c; (c = r(a, b)) && a.setAttribute("class", (a[i]("class") || "").replace(c, " ")) }, u = function (a, b, c) { var d = c ? h : "removeEventListener"; c && u(a, b), o.forEach(function (c) { a[d](c, b) }) }, v = function (a, d, e, f, g) { var h = b.createEvent("Event"); return e || (e = {}), e.instance = c, h.initEvent(d, !f, !g), h.detail = e, a.dispatchEvent(h), h }, w = function (b, c) { var e; !g && (e = a.picturefill || d.pf) ? (c && c.src && !b[i]("srcset") && b.setAttribute("srcset", c.src), e({ reevaluate: !0, elements: [b] })) : c && c.src && (b.src = c.src) }, x = function (a, b) { return (getComputedStyle(a, null) || {})[b] }, y = function (a, b, c) { for (c = c || a.offsetWidth; c < d.minSize && b && !a._lazysizesWidth;)c = b.offsetWidth, b = b.parentNode; return c }, z = function () { var a, c, d = [], e = [], f = d, g = function () { var b = f; for (f = d.length ? e : d, a = !0, c = !1; b.length;)b.shift()(); a = !1 }, h = function (d, e) { a && !e ? d.apply(this, arguments) : (f.push(d), c || (c = !0, (b.hidden ? k : l)(g))) }; return h._lsFlush = g, h }(), A = function (a, b) { return b ? function () { z(a) } : function () { var b = this, c = arguments; z(function () { a.apply(b, c) }) } }, B = function (a) { var b, c = 0, e = d.throttleDelay, g = d.ricTimeout, h = function () { b = !1, c = f.now(), a() }, i = m && g > 49 ? function () { m(h, { timeout: g }), g !== d.ricTimeout && (g = d.ricTimeout) } : A(function () { k(h) }, !0); return function (a) { var d; (a = !0 === a) && (g = 33), b || (b = !0, d = e - (f.now() - c), d < 0 && (d = 0), a || d < 9 ? i() : k(i, d)) } }, C = function (a) { var b, c, d = 99, e = function () { b = null, a() }, g = function () { var a = f.now() - c; a < d ? k(g, d - a) : (m || e)(e) }; return function () { c = f.now(), b || (b = k(g, d)) } }; !function () { var b, c = { lazyClass: "lazyload", loadedClass: "lazyloaded", loadingClass: "lazyloading", preloadClass: "lazypreload", errorClass: "lazyerror", autosizesClass: "lazyautosizes", srcAttr: "data-src", srcsetAttr: "data-srcset", sizesAttr: "data-sizes", minSize: 40, customMedia: {}, init: !0, expFactor: 1.5, hFac: .8, loadMode: 2, loadHidden: !0, ricTimeout: 0, throttleDelay: 125 }; d = a.lazySizesConfig || a.lazysizesConfig || {}; for (b in c) b in d || (d[b] = c[b]); a.lazySizesConfig = d, k(function () { d.init && F() }) }(); var D = function () { var g, l, m, o, p, y, D, F, G, H, I, J, K = /^img$/i, L = /^iframe$/i, M = "onscroll" in a && !/(gle|ing)bot/.test(navigator.userAgent), N = 0, O = 0, P = 0, Q = -1, R = function (a) { P-- , (!a || P < 0 || !a.target) && (P = 0) }, S = function (a) { return null == J && (J = "hidden" == x(b.body, "visibility")), J || "hidden" != x(a.parentNode, "visibility") && "hidden" != x(a, "visibility") }, T = function (a, c) { var d, f = a, g = S(a); for (F -= c, I += c, G -= c, H += c; g && (f = f.offsetParent) && f != b.body && f != e;)(g = (x(f, "opacity") || 1) > 0) && "visible" != x(f, "overflow") && (d = f.getBoundingClientRect(), g = H > d.left && G < d.right && I > d.top - 1 && F < d.bottom + 1); return g }, U = function () { var a, f, h, j, k, m, n, p, q, r, s, t, u = c.elements; if ((o = d.loadMode) && P < 8 && (a = u.length)) { for (f = 0, Q++; f < a; f++)if (u[f] && !u[f]._lazyRace) if (!M || c.prematureUnveil && c.prematureUnveil(u[f])) aa(u[f]); else if ((p = u[f][i]("data-expand")) && (m = 1 * p) || (m = O), r || (r = !d.expand || d.expand < 1 ? e.clientHeight > 500 && e.clientWidth > 500 ? 500 : 370 : d.expand, c._defEx = r, s = r * d.expFactor, t = d.hFac, J = null, O < s && P < 1 && Q > 2 && o > 2 && !b.hidden ? (O = s, Q = 0) : O = o > 1 && Q > 1 && P < 6 ? r : N), q !== m && (y = innerWidth + m * t, D = innerHeight + m, n = -1 * m, q = m), h = u[f].getBoundingClientRect(), (I = h.bottom) >= n && (F = h.top) <= D && (H = h.right) >= n * t && (G = h.left) <= y && (I || H || G || F) && (d.loadHidden || S(u[f])) && (l && P < 3 && !p && (o < 3 || Q < 4) || T(u[f], m))) { if (aa(u[f]), k = !0, P > 9) break } else !k && l && !j && P < 4 && Q < 4 && o > 2 && (g[0] || d.preloadAfterLoad) && (g[0] || !p && (I || H || G || F || "auto" != u[f][i](d.sizesAttr))) && (j = g[0] || u[f]); j && !k && aa(j) } }, V = B(U), W = function (a) { var b = a.target; if (b._lazyCache) return void delete b._lazyCache; R(a), s(b, d.loadedClass), t(b, d.loadingClass), u(b, Y), v(b, "lazyloaded") }, X = A(W), Y = function (a) { X({ target: a.target }) }, Z = function (a, b) { try { a.contentWindow.location.replace(b) } catch (c) { a.src = b } }, $ = function (a) { var b, c = a[i](d.srcsetAttr); (b = d.customMedia[a[i]("data-media") || a[i]("media")]) && a.setAttribute("media", b), c && a.setAttribute("srcset", c) }, _ = A(function (a, b, c, e, f) { var g, h, j, l, o, p; (o = v(a, "lazybeforeunveil", b)).defaultPrevented || (e && (c ? s(a, d.autosizesClass) : a.setAttribute("sizes", e)), h = a[i](d.srcsetAttr), g = a[i](d.srcAttr), f && (j = a.parentNode, l = j && n.test(j.nodeName || "")), p = b.firesLoad || "src" in a && (h || g || l), o = { target: a }, s(a, d.loadingClass), p && (clearTimeout(m), m = k(R, 2500), u(a, Y, !0)), l && q.call(j.getElementsByTagName("source"), $), h ? a.setAttribute("srcset", h) : g && !l && (L.test(a.nodeName) ? Z(a, g) : a.src = g), f && (h || l) && w(a, { src: g })), a._lazyRace && delete a._lazyRace, t(a, d.lazyClass), z(function () { var b = a.complete && a.naturalWidth > 1; p && !b || (b && s(a, "ls-is-cached"), W(o), a._lazyCache = !0, k(function () { "_lazyCache" in a && delete a._lazyCache }, 9)), "lazy" == a.loading && P-- }, !0) }), aa = function (a) { if (!a._lazyRace) { var b, c = K.test(a.nodeName), e = c && (a[i](d.sizesAttr) || a[i]("sizes")), f = "auto" == e; (!f && l || !c || !a[i]("src") && !a.srcset || a.complete || r(a, d.errorClass) || !r(a, d.lazyClass)) && (b = v(a, "lazyunveilread").detail, f && E.updateElem(a, !0, a.offsetWidth), a._lazyRace = !0, P++ , _(a, b, f, e, c)) } }, ba = C(function () { d.loadMode = 3, V() }), ca = function () { 3 == d.loadMode && (d.loadMode = 2), ba() }, da = function () { if (!l) { if (f.now() - p < 999) return void k(da, 999); l = !0, d.loadMode = 3, V(), j("scroll", ca, !0) } }; return { _: function () { p = f.now(), c.elements = b.getElementsByClassName(d.lazyClass), g = b.getElementsByClassName(d.lazyClass + " " + d.preloadClass), j("scroll", V, !0), j("resize", V, !0), a.MutationObserver ? new MutationObserver(V).observe(e, { childList: !0, subtree: !0, attributes: !0 }) : (e[h]("DOMNodeInserted", V, !0), e[h]("DOMAttrModified", V, !0), setInterval(V, 999)), j("hashchange", V, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function (a) { b[h](a, V, !0) }), /d$|^c/.test(b.readyState) ? da() : (j("load", da), b[h]("DOMContentLoaded", V), k(da, 2e4)), c.elements.length ? (U(), z._lsFlush()) : V() }, checkElems: V, unveil: aa, _aLSL: ca } }(), E = function () { var a, c = A(function (a, b, c, d) { var e, f, g; if (a._lazysizesWidth = d, d += "px", a.setAttribute("sizes", d), n.test(b.nodeName || "")) for (e = b.getElementsByTagName("source"), f = 0, g = e.length; f < g; f++)e[f].setAttribute("sizes", d); c.detail.dataAttr || w(a, c.detail) }), e = function (a, b, d) { var e, f = a.parentNode; f && (d = y(a, f, d), e = v(a, "lazybeforesizes", { width: d, dataAttr: !!b }), e.defaultPrevented || (d = e.detail.width) && d !== a._lazysizesWidth && c(a, f, e, d)) }, f = function () { var b, c = a.length; if (c) for (b = 0; b < c; b++)e(a[b]) }, g = C(f); return { _: function () { a = b.getElementsByClassName(d.autosizesClass), j("resize", g) }, checkElems: g, updateElem: e } }(), F = function () { F.i || (F.i = !0, E._(), D._()) }; return c = { cfg: d, autoSizer: E, loader: D, init: F, uP: w, aC: s, rC: t, hC: r, fire: v, gW: y, rAF: z } } });
	/*! ls.rias.min.ks - v4.1.8 */
	!function (a, b) { var c = function () { b(a.lazySizes), a.removeEventListener("lazyunveilread", c, !0) }; b = b.bind(null, a, a.document), "object" == typeof module && module.exports ? b(require("lazysizes")) : a.lazySizes ? c() : a.addEventListener("lazyunveilread", c, !0) }(window, function (a, b, c) { "use strict"; function d(b, c) { var d, e, f, g, h = a.getComputedStyle(b); e = b.parentNode, g = { isPicture: !(!e || !m.test(e.nodeName || "")) }, f = function (a, c) { var d = b.getAttribute("data-" + a); if (!d) { var e = h.getPropertyValue("--ls-" + a); e && (d = e.trim()) } if (d) { if ("true" == d) d = !0; else if ("false" == d) d = !1; else if (l.test(d)) d = parseFloat(d); else if ("function" == typeof j[a]) d = j[a](b, d); else if (q.test(d)) try { d = JSON.parse(d) } catch (a) { } g[a] = d } else a in j && "function" != typeof j[a] ? g[a] = j[a] : c && "function" == typeof j[a] && (g[a] = j[a](b, d)) }; for (d in j) f(d); return c.replace(p, function (a, b) { b in g || f(b, !0) }), g } function e(a, b) { var c = [], d = function (a, c) { return k[typeof b[c]] ? b[c] : a }; return c.srcset = [], b.absUrl && (s.setAttribute("href", a), a = s.href), a = ((b.prefix || "") + a + (b.postfix || "")).replace(p, d), b.widths.forEach(function (d) { var e = b.widthmap[d] || d, f = b.aspectratio || b.ratio, g = !b.aspectratio && j.traditionalRatio, h = { u: a.replace(n, e).replace(o, f ? g ? Math.round(d * f) : Math.round(d / f) : ""), w: d }; c.push(h), c.srcset.push(h.c = h.u + " " + d + "w") }), c } function f(a, c, d) { var f = 0, g = 0, h = d; if (a) { if ("container" === c.ratio) { for (f = h.scrollWidth, g = h.scrollHeight; !(f && g || h === b);)h = h.parentNode, f = h.scrollWidth, g = h.scrollHeight; f && g && (c.ratio = g / f) } a = e(a, c), a.isPicture = c.isPicture, u && "IMG" == d.nodeName.toUpperCase() ? d.removeAttribute(i.srcsetAttr) : d.setAttribute(i.srcsetAttr, a.srcset.join(", ")), Object.defineProperty(d, "_lazyrias", { value: a, writable: !0 }) } } function g(a, b) { var e = d(a, b); return j.modifyOptions.call(a, { target: a, details: e, detail: e }), c.fire(a, "lazyriasmodifyoptions", e), e } function h(a) { return a.getAttribute(a.getAttribute("data-srcattr") || j.srcAttr) || a.getAttribute(i.srcsetAttr) || a.getAttribute(i.srcAttr) || a.getAttribute("data-pfsrcset") || "" } var i, j, k = { string: 1, number: 1 }, l = /^\-*\+*\d+\.*\d*$/, m = /^picture$/i, n = /\s*\{\s*width\s*\}\s*/i, o = /\s*\{\s*height\s*\}\s*/i, p = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi, q = /^\[.*\]|\{.*\}$/, r = /^(?:auto|\d+(px)?)$/, s = b.createElement("a"), t = b.createElement("img"), u = "srcset" in t && !("sizes" in t), v = !!a.HTMLPictureElement && !u; !function () { var b, d = function () { }, e = { prefix: "", postfix: "", srcAttr: "data-src", absUrl: !1, modifyOptions: d, widthmap: {}, ratio: !1, traditionalRatio: !1, aspectratio: !1 }; i = c && c.cfg || a.lazySizesConfig, i || (i = {}, a.lazySizesConfig = i), i.supportsType || (i.supportsType = function (a) { return !a }), i.rias || (i.rias = {}), "widths" in (j = i.rias) || (j.widths = [], function (a) { for (var b, c = 0; !b || b < 3e3;)c += 5, c > 30 && (c += 1), b = 36 * c, a.push(b) }(j.widths)); for (b in e) b in j || (j[b] = e[b]) }(), addEventListener("lazybeforesizes", function (a) { if (a.detail.instance == c) { var b, d, e, k, l, m, o, p, q, s, t, u, x; if (b = a.target, a.detail.dataAttr && !a.defaultPrevented && !j.disabled && (q = b.getAttribute(i.sizesAttr) || b.getAttribute("sizes")) && r.test(q)) { if (d = h(b), e = g(b, d), t = n.test(e.prefix) || n.test(e.postfix), e.isPicture && (k = b.parentNode)) for (l = k.getElementsByTagName("source"), m = 0, o = l.length; m < o; m++)(t || n.test(p = h(l[m]))) && (f(p, e, l[m]), u = !0); t || n.test(d) ? (f(d, e, b), u = !0) : u && (x = [], x.srcset = [], x.isPicture = !0, Object.defineProperty(b, "_lazyrias", { value: x, writable: !0 })), u && (v ? b.removeAttribute(i.srcAttr) : "auto" != q && (s = { width: parseInt(q, 10) }, w({ target: b, detail: s }))) } } }, !0); var w = function () { var d = function (a, b) { return a.w - b.w }, e = function (a) { var b, c, d = a.length, e = a[d - 1], f = 0; for (f; f < d; f++)if (e = a[f], e.d = e.w / a.w, e.d >= a.d) { !e.cached && (b = a[f - 1]) && b.d > a.d - .13 * Math.pow(a.d, 2.2) && (c = Math.pow(b.d - .6, 1.6), b.cached && (b.d += .15 * c), b.d + (e.d - a.d) * c > a.d && (e = b)); break } return e }, f = function (a, b) { var d; return !a._lazyrias && c.pWS && (d = c.pWS(a.getAttribute(i.srcsetAttr || ""))).length && (Object.defineProperty(a, "_lazyrias", { value: d, writable: !0 }), b && a.parentNode && (d.isPicture = "PICTURE" == a.parentNode.nodeName.toUpperCase())), a._lazyrias }, g = function (b) { var d = a.devicePixelRatio || 1, e = c.getX && c.getX(b); return Math.min(e || d, 2.4, d) }, h = function (b, c) { var h, i, j, k, l, m; if (l = b._lazyrias, l.isPicture && a.matchMedia) for (i = 0, h = b.parentNode.getElementsByTagName("source"), j = h.length; i < j; i++)if (f(h[i]) && !h[i].getAttribute("type") && (!(k = h[i].getAttribute("media")) || (matchMedia(k) || {}).matches)) { l = h[i]._lazyrias; break } return (!l.w || l.w < c) && (l.w = c, l.d = g(b), m = e(l.sort(d))), m }, j = function (d) { if (d.detail.instance == c) { var e, g = d.target; if (!u && (a.respimage || a.picturefill || lazySizesConfig.pf)) return void b.removeEventListener("lazybeforesizes", j); ("_lazyrias" in g || d.detail.dataAttr && f(g, !0)) && (e = h(g, d.detail.width)) && e.u && g._lazyrias.cur != e.u && (g._lazyrias.cur = e.u, e.cached = !0, c.rAF(function () { g.setAttribute(i.srcAttr, e.u), g.setAttribute("src", e.u) })) } }; return v ? j = function () { } : addEventListener("lazybeforesizes", j), j }() });
  }
  
  // Fix the confict suggestion search in Debut theme
  if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;
  // Override Settings
  var boostPFSFilterConfig = {
	  general: {
		  limit: boostPFSThemeConfig.custom.products_per_page,
		  /* Optional */
		  loadProductFirst: true,
		  // Placeholder  
		  showPlaceholderProductList: true,
          activeLoadPreviousPage: true, 
		  placeholderProductPerRow: 4,
		  placeholderProductGridItemClass: 'boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-4 boost-pfs-filter-grid-width-mb-2',
		  enableOTP: true,
		  separateRefineByFromFilter: true,
		  filterTreeEnableRenderPartially: false,
		  filterTreeMobileStyle: 'style3', // 'style2', 'style3',
		  equal_height: boostPFSThemeConfig.custom.equal_height,
		  cropImagePossitionEqualHeight: boostPFSThemeConfig.custom.equal_height_crop_image_position,
		  defaultDisplay: boostPFSThemeConfig.custom.product_item_type
	  },
	  search: {
		suggestionProductItemPerRow: "1"
	  },
	  selector: {
		  otpButtons: '.boost-pfs-filter-product-item-image'
	  }
  };
  
  (function() {
	  var onSale = false,
		  soldOut = false,
		  priceVaries = false,
		  images = [],
		  firstVariant = {},
		  boostPFSImgDefaultSrc = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
		  boostPFSRangeWidths = [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048];

	  $.global_coll_count = [];

	  BoostPFS.inject(this);
  
	  /************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	  function prepareShopifyData(data) {
		  // Displaying price base on the policy of Shopify, have to multiple by 100
		  soldOut = !data.available; // Check a product is out of stock
		  onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		  priceVaries = data.price_min != data.price_max; // Check a product has many prices
		  // Convert images to array
		  images = data.images_info;
		  // Get First Variant (selected_or_first_available_variant)
		  firstVariant = data['variants'][0];
		  if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			  var paramVariant = data.variants.filter(function(e) {
				  return e.id == Utils.getParam('variant');
			  });
			  if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		  } else {
			  for (var i = 0; i < data['variants'].length; i++) {
				  if (data['variants'][i].available) {
					  firstVariant = data['variants'][i];
					  break;
				  }
			  }
		  }
		  return data;
	  }
  
	  /************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	  /************************** BUILD PRODUCT LIST **************************/
	  // Build Product Grid Item
	  ProductGridItem.prototype.compileTemplate = function(data) {
		  if (!data) data = this.data;
		  // Customize API data to get the Shopify data
		  data = prepareShopifyData(data);
  
		  // Get Template
		  var itemHtml = boostPFSTemplate.productGridItemHtml;
		  // Add Custom class
		  var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		  var saleClass = onSale ? boostPFSTemplate.saleClass : '';
  
		  itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
		  itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
		  // Add Grid Width class
		  itemHtml = itemHtml.replace(/{{gridWidthClass}}/g, buildGridWidthClass(data));
		  // Add Label
		  itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
		  // Add TAG Label
		  itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
		  // Add Bra Size TAG Label
		  itemHtml = itemHtml.replace(/{{itemBraSizeLabels}}/g, buildBraSizeLabels(data));
		  // Add Images
		  itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
		  // Add Modal Images
		  itemHtml = itemHtml.replace(/{{itemModalImages}}/g, buildModalImages(data));
		  // Add Price
		  itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
		  // Add size Available
		  // itemHtml = itemHtml.replace(/{{sizeAvailable}}/g, buildSizeAvailable(data));
		  // Add Module TAG Label
		  itemHtml = itemHtml.replace(/{{itemModuleLabels}}/g, buildModuleTagLabels(data));
		  // Add Modal Price
		  itemHtml = itemHtml.replace(/{{itemModalPrice}}/g, buildModalPrice(data));
		  // Add Modal Price
		  itemHtml = itemHtml.replace(/{{itemDescription}}/g, buildModalDescription(data));
		  // Add Modal Form Tags
		  itemHtml = itemHtml.replace(/{{itemModalFormTag}}/g, buildModalFormTagLabels(data));
		  // Add Modal Form Size Options
		  itemHtml = itemHtml.replace(/{{itemModalSelectVariants}}/g, buildModalFormSelectVariants(data));
		  // Add Modal All Tags
		  itemHtml = itemHtml.replace(/{{itemModalAllTags}}/g, buildModalFormAllTags(data));
		  // Add Modal Image Featured Link
		  itemHtml = itemHtml.replace(/{{itemImgFeaturedLink}}/g, buildModalImgFeaturedLink());
		  //-- Add item variant id
		  itemHtml = itemHtml.replace(/{{itemVariantId}}/g, data.variants[0].id);
		  //-- Item color count
		  itemHtml = itemHtml.replace(/{{itemColorCount}}/g, buildColorCount(data));
		  //-- Add Quick Shop Button
		  itemHtml = itemHtml.replace(/{{itemQuickShopButton}}/g, buildQuickShopButton(data));
		  // Add Review
		  if (typeof Integration === 'undefined' ||
			  (typeof Integration != 'undefined' &&
				  typeof Integration.hascompileTemplate == 'function' &&
				  !Integration.hascompileTemplate('reviews'))) {
			  itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
		  }
  
		  // Add Vendor
		  itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
  
		  // itemActiveSwapClass
		  itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, buildActiveSwapClass(data));
		  // Add Color Swatches
		  itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, buildColorSwatches(data));
  
		  // Add main attribute (Always put at the end of this function)
		  itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		  itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		  itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		  itemHtml = itemHtml.replace(/{{itemUrl}}/g, "/products/" + data.handle);
		  return itemHtml;
	  };
	  // Build Product List Item
	  ProductListItem.prototype.compileTemplate = function(data) {
		  if (!data) data = this.data;
		  // Customize API data to get the Shopify data
		  data = prepareShopifyData(data);
  
		  // For List View
		  // Get Template
		  var itemHtml = boostPFSTemplate.productListItemHtml;
  
		  // Add Custom class
		  var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		  var saleClass = onSale ? boostPFSTemplate.saleClass : '';
  
		  itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
		  itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
		  // Add Label
		  itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
		  // Add TAG Label
		  itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
		  // Add Images
		  itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
  
		  // Add Review
		  if (typeof Integration === 'undefined' ||
			  (typeof Integration != 'undefined' &&
				  typeof Integration.hascompileTemplate == 'function' &&
				  !Integration.hascompileTemplate('reviews'))) {
			  itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
		  }
  
		  // Add Vendor
		  itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
  
		  // Add Price
		  var itemPriceHtml = buildPrice(data, onSale, priceVaries);
		  itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
  
		  // Description
		  var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
		  itemDescription = (itemDescription.split(" ")).length > 35 ? itemDescription.split(" ").splice(0, 35).join(" ") + '...' : itemDescription.split(" ").splice(0, 35).join(" ");
		  itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
  
		  // itemActiveSwapClass
		  itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, buildActiveSwapClass(data));
  
		  // Add Color Swatches
		  itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, buildColorSwatches(data));
  
		  // Add main attribute
		  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		  itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		  itemHtml = itemHtml.replace(/{{itemUrl}}/g, "/products/" + data.handle);
		  itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
  
		  return itemHtml;
		  // End For List View
	  };
  
	  /************************** END BUILD PRODUCT LIST **************************/
	  /************************** BUILD PRODUCT ITEM ELEMENTS **************************/
	  /* #_CUSTOM SCRIPTS 20 APRIL 2021 */
	  function buildSizeAvailable(data){
		  var html = "Sizes Available: ";
		  for (var i = 0; i < data['variants'].length; i++) {
			  if (data['variants'][i].available) {
				  if(i == 0){
					  html += data['variants'][i].title;
				  }else{
					  html += ", "+data['variants'][i].title;
				  }
			  }
		  }
		  return html;
	  }
  
	  function buildModalFormSelectVariants(data){
		  var html = "";
		  var lt = data.options.length;
		  if(lt > 1){
			  if(lt == 2 && data.options[1] == "BuyXDiscount"){
				  lt = 1;
			  }
			  if(lt == 3 && data.options[2] == "BuyXDiscount"){
				  lt = 2;
			  }
		  }
		  
		  if(lt > 1){
			html += `<div class="select select-buyx_product_options_size">
				<select id="product-select-${data.id}" name="id" class="multi_select">`;
			data.variants.forEach(vr => {
				if(! vr.title.includes("% Off")) {
					var isDisabled = "";
					if(vr.inventory_quantity < 1 && vr.inventory_policy == "deny"){
						isDisabled = 'disabled="disabled"';
					}

					let textAfterVariant = '';
					if(vr.inventory_quantity == 0 && vr.inventory_policy == 'deny'){
					textAfterVariant = "— Sold Out";
					} else if(vr.inventory_quantity < 5 && vr.inventory_policy == 'deny'){
						textAfterVariant = " — Only "+ vr.inventory_quantity +" Left";
					}
					
					if(vr == firstVariant){
						html += `<option value="${vr.id}" data-sku="${vr.sku}" data-inventory="${vr.inventory_quantity}" data-policy="${vr.inventory_policy}" selected="selected" ${isDisabled}>${vr.title}${textAfterVariant}</option>`;
					}else{
						html += `<option value="${vr.id}" data-sku="${vr.sku}" data-inventory="${vr.inventory_quantity}" data-policy="${vr.inventory_policy}" ${isDisabled}>${vr.title}${textAfterVariant}</option>`;
					}
				}
			});
			html += '</select></div>';
		  }else if(lt == 1 && data.variants.length > 1){
			html += '<div class="select select-buyx_product_options_size-variants">'+
			'<label>'+data.options[0]+'</label>'+
			'<select id="product-select-'+data.id+'" name="id" class="multi_select">';
			data.variants.forEach(vr => {
				if(! vr.title.includes("% Off")) {
					var isDisabled = "";
					if(vr.inventory_quantity < 1 && vr.inventory_policy == "deny"){
						isDisabled = 'disabled="disabled"';
					}

					let textAfterVariant = '';
					if(vr.inventory_quantity == 0 && vr.inventory_policy == 'deny'){
					  textAfterVariant = "— Sold Out";
					} else if(vr.inventory_quantity < 5 && vr.inventory_policy == 'deny'){
						textAfterVariant = " — Only "+ vr.inventory_quantity +" Left";
					}
					
					if(vr == firstVariant){
						html += `<option value="${vr.id}" data-sku="${vr.sku}" data-inventory="${vr.inventory_quantity}" data-policy="${vr.inventory_policy}" selected="selected" ${isDisabled}>${vr.title}${textAfterVariant}</option>`;
					}else{
						html += `<option value="${vr.id}" data-sku="${vr.sku}" data-inventory="${vr.inventory_quantity}" data-policy="${vr.inventory_policy}" ${isDisabled}>${vr.title}${textAfterVariant}</option>`;
					}
				}
			});
			html += '</select></div>';
		  }else{
			  html += '<input type="hidden" name="id" value="'+data.variants[0].id+'" />'
		  }
		  return html;
	  }
  
	  function buildModuleTagLabels(data) {
		  var html = "";
		  if(ENABLE_MODULE && ENABLE_MODULE_V2){
			  if(! data.tags.includes(x_tag_v2)){
				  if(data.tags.includes(x_tag) && label_tag_x != ''){
					  html =  '<div class="sticker p4 pt-5 pb-5 pl-10 pr-10 bg-black c-white uppercase tag-x">'+label_tag_x+'</div>';
				  }
			  }else{
				  if(! data.tags.includes(x_tag)){
					  if(data.tags.includes(x_tag_v2) && label_tag_x_v2 != ''){
						  html = '<div class="sticker p4 pt-5 pb-5 pl-10 pr-10 bg-black c-white uppercase tag-x-v2">'+label_tag_x_v2+'</div>';
					  }
				  }
			  }
		  }else{
			  if(ENABLE_MODULE){
				  if(! data.tags.includes(x_tag_v2)){
					   if(data.tags.includes(x_tag) && label_tag_x != ''){
						  html =  '<div class="sticker p4 pt-5 pb-5 pl-10 pr-10 bg-black c-white uppercase tag-x">'+label_tag_x+'</div>';
					  }
				  }
			  }else{
				  if(ENABLE_MODULE_V2){
					  if(! data.tags.includes(x_tag)){
						  if(data.tags.includes(x_tag_v2) && label_tag_x_v2 != ''){
							  html = '<div class="sticker p4 pt-5 pb-5 pl-10 pr-10 bg-black c-white uppercase tag-x-v2">'+label_tag_x_v2+'</div>';
						  }
					  }
				  }
			  }
		  }

		  //-- custom tags
		  var arr_sticker_enabled = boostPFSAppConfig.general.isEnableSticker;
		  var arr_sticker_tags = boostPFSAppConfig.general.strickerTags.split('|');
		  var arr_sticker_bgs = boostPFSAppConfig.general.strickerBgs.split('|');
		  var arr_sticker_colors = boostPFSAppConfig.general.strickerColors.split('|');

		  if(arr_sticker_enabled) {
			  for(var i=0; i<arr_sticker_tags.length; i++) {
				  if(arr_sticker_tags[i] != '' && data.tags.includes(arr_sticker_tags[i].toLowerCase())) {
					html += '<div class="sticker p4 pt-5 pb-5 pl-10 pr-10 uppercase" style="background:'+arr_sticker_bgs[i]+'; color:'+arr_sticker_colors[i]+'">'+arr_sticker_tags[i]+'</div>';
				  }
			  }
		  }

		  return html;
	  }
	  function buildBraSizeLabels(data) {
		  var html = "";
			if (data.product_type) {
				
				var brasize = '';
				if (data.variants) {
					let variants = []
					data.variants.map(function(item) {
							variants.push(item)
					})
					var lastVariant = variants[variants.length - 1];
					brasize = lastVariant.option_size;
				}
				var typebra = data.product_type.toLowerCase();
				if (typebra.indexOf("bra") !== -1 && brasize != "") {
					html =  '<div class="sticker p4 pt-5 pb-5 pl-10 pr-10 bg-white c-black uppercase" style>'+'up to'+' '+brasize+'</div>';
				}		  
			}
		  return html;
	  }
  
	  function buildModalFormAllTags(data) {
		  var html = '';
		  data.tags.forEach(tag => {
			  html += ' ptags-'+tag.replace(/['"]+/g, '');
		  });
		  return html;
	  }
	  
	  function buildModalFormTagLabels(data) {
		  var html = "";		
		  if(data.tags.includes(x_tag)){
			  html +=  'data-tag_x="true" ';
		  }else{
			  html +=  'data-tag_x="false" ';
		  }
  
		  if(data.tags.includes(x_tag_v2)){
			  html +=  'data-tag_x_v2="true" ';
		  }else{
			  html +=  'data-tag_x_v2="false" ';
		  }
		  return html;
	  }
  
	  function buildModalPrice(data){
		  var html = '';
		  if (boostPFSThemeConfig.custom.hasOwnProperty('show_price') &&
			  boostPFSThemeConfig.custom.show_price) {
			  html = '<p class="modal_price">';
			  if (onSale) {
  
				  html += '<s>' + Utils.formatMoney(data.compare_at_price_min).replace(" GBP", "")  + '</s> ';
				  html += '<span class="boost-pfs-filter-product-item-sale-price">' + Utils.formatMoney(data.price_min).replace(" GBP", "")  + '</span>';
				  
			  } else {
				  if (priceVaries) {
					  html += '<span class="boost-pfs-filter-product-item-price-from-text">' + (boostPFSThemeConfig.label_basic.from) + ' ' + '</span>';
				  }
				  html += '<span class="current_price">' + Utils.formatMoney(data.price_min).replace(" GBP", "") + '</span>';
			  }
			  html += '</p>';
		  }
		  return html;
	  }
  
	  function buildModalDescription(data){
          var desc = "";
          if(data.description != null) {
            desc = data.description.replace(/(<([^>]+)>)/gi, "");
    		  desc = desc.replace("Description", "");
    		  desc = desc.replace("Dimensions", "");
    		  desc = desc.replace("Details", "");
    		  desc = desc.replace("Specs", "");
    		  desc = desc.replace("Shipping", "");
    		  desc = truncateString(desc, 200);
          }
        
		  return desc;
	  }
  
	  function buildModalImgFeaturedLink() {
		  var html = '';
		  html += Utils.getFeaturedImage(images, '480x');
		  return html;
	  }
  
	  function buildModalImages(data) {
		  var html = '',
			  aspectRatio = '',
			  rangeWidths = boostPFSRangeWidths,
			  paddingTop = 100;
  
		  var dataSrcSet = '',
			  dataWidths = '',
			  dataSizes = 'auto',
			  imgAlt = data.title,
			  flipImageSrcSet = '';
  
		  var activeSwapImage = !Utils.isMobile() && images.length > 1 &&
			  boostPFSThemeConfig.custom.hasOwnProperty('active_image_swap') &&
			  boostPFSThemeConfig.custom.active_image_swap == true;
  
		  for (var i = 0; i < rangeWidths.length; i++) {
			  dataSrcSet += Utils.getFeaturedImage(images, rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
			  dataWidths += rangeWidths[i];
  
			  if (activeSwapImage) {
				  flipImageSrcSet += Utils.optimizeImage(images[1]['src'], rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
			  }
  
			  if (i < rangeWidths.length - 1) {
				  dataSrcSet += ', ';
				  dataWidths += ', ';
  
				  if (activeSwapImage) {
					  flipImageSrcSet += ', ';
				  }
			  }
		  }
  
		  html += '<img class="boost-pfs-filter-product-item-main-image lazyload Image--lazyLoad lazy"' +
			  'data-srcset="' + dataSrcSet + '" ' +
			  'data-src="' + Utils.getFeaturedImage(images, rangeWidths[2] + 'x') + '" ' +
			  'data-widths="[' + dataWidths + ']" ' +
			  'data-sizes="' + dataSizes + '" ' +
			  'src="' + boostPFSImgDefaultSrc + '" ' +
			  'alt="' + imgAlt + '" ';
		  html += '/>';
		  return html;
	  }
  
	  function truncateString(str, num) {
		  if (str.length <= num) {
			return str
		  }
		  return str.slice(0, num) + '...';
	  }
  
	  function buildGridWidthClass() {
		  var gridWidthClass = '';
		  // On PC
		  switch (boostPFSThemeConfig.custom.products_per_row) {
			  case 2:
				  gridWidthClass = 'boost-pfs-filter-grid-width-2';
				  break;
			  case 3:
				  gridWidthClass = 'boost-pfs-filter-grid-width-3';
				  break;
			  case 5:
				  gridWidthClass = 'boost-pfs-filter-grid-width-5';
				  break;
			  case 6:
				  gridWidthClass = 'boost-pfs-filter-grid-width-6';
				  break;
			  default:
				  gridWidthClass = 'boost-pfs-filter-grid-width-4';
				  break;
		  }
		  // On Mobile
		  switch (boostPFSThemeConfig.custom.products_per_row_mobile) {
			  case 1:
				  gridWidthClass += ' boost-pfs-filter-grid-width-mb-1';
				  break;
			  case 3:
				  gridWidthClass += ' boost-pfs-filter-grid-width-mb-3';
				  break;
			  default:
				  gridWidthClass += ' boost-pfs-filter-grid-width-mb-2';
				  break;
		  }
		  return gridWidthClass;
	  }
  
	  function buildImages(data) {
		  var html = '',
			  aspectRatio = '',
			  rangeWidths = boostPFSRangeWidths,
			  paddingTop = 100;
  
		  var dataSrcSet = '',
			  dataWidths = '',
			  dataSizes = 'auto',
			  imgAlt = data.title,
			  flipImageSrcSet = '';
  
		  var activeSwapImage = !Utils.isMobile() && images.length > 1 &&
			  boostPFSThemeConfig.custom.hasOwnProperty('active_image_swap') &&
			  boostPFSThemeConfig.custom.active_image_swap == true;
  
		  for (var i = 0; i < rangeWidths.length; i++) {
			  dataSrcSet += Utils.getFeaturedImage(images, rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
			  dataWidths += rangeWidths[i];
  
			  if (activeSwapImage) {
				  flipImageSrcSet += Utils.optimizeImage(images[1]['src'], rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
			  }
  
			  if (i < rangeWidths.length - 1) {
				  dataSrcSet += ', ';
				  dataWidths += ', ';
  
				  if (activeSwapImage) {
					  flipImageSrcSet += ', ';
				  }
			  }
		  }
  
		  if (images.length > 0) {
			  aspectRatio = images[0]['width'] / images[0]['height'];
			  paddingTop = 1 / aspectRatio * 100;
		  }
  
		  let coreImage = '';
		  let fullBustImage = '';
		  let curveImage = '';
		  let coreHoverImage = '';
		  let fullBustHoverImage = '';
		  let curveHoverImage = '';
		  images.forEach(image => {
			const img_alt = image.alt + '';

			  if(img_alt.indexOf('Core') >= 0) {
				  if(coreImage == '')
				  {
				  coreImage = image.src;
				  }
				  else if (coreHoverImage == '')
				  {
					coreHoverImage = image.src;
				  }
			  }
			  if(img_alt.indexOf('Fuller Bust') >= 0) {
				  if(fullBustImage == '')
				  {
				  fullBustImage = image.src;
				  }
				  else if (fullBustHoverImage == '')
				  {
					fullBustHoverImage = image.src;
				  }
			  }
			  if(img_alt.indexOf('Curve') >= 0) {
				  if(curveImage == '')
				  {
				  curveImage = image.src;
				  }
				  else if (curveHoverImage == '')
				  {
					curveHoverImage = image.src;
				  }
			  }
		  })

		  if(coreHoverImage == ''){coreHoverImage = coreImage;}
		  if(fullBustHoverImage == ''){fullBustHoverImage = fullBustImage;}
		  if(curveHoverImage == ''){curveHoverImage = curveImage;}
		  
  console.log('current size group', currentSizeGroup);

  defaultImage = Utils.getFeaturedImage(images, rangeWidths[2] + 'x');
  hoverImage = Utils.getFeaturedImage(images, rangeWidths[2] + 'x');
  if(activeSwapImage)
  {
	hoverImage = Utils.optimizeImage(images[1]['src'], rangeWidths[2] + 'x');
  }
  currentImage = defaultImage;
  currentHoverImage = hoverImage;
  if(currentSizeGroup == 'Core' && coreImage != "")
  {
	currentImage = coreImage;
	currentHoverImage = coreHoverImage;
	dataSrcSet = coreImage;
	flipImageSrcSet = coreHoverImage;
  }
  else if(currentSizeGroup == 'Curve' && curveImage != "")
  {
	currentImage = curveImage;
	currentHoverImage = curveHoverImage;
	dataSrcSet = curveImage;
	flipImageSrcSet = curveHoverImage;
  }
  else if(currentSizeGroup == 'Fuller Bust' && fullBustImage != "")
  {
	currentImage = fullBustImage;
	currentHoverImage = fullBustHoverImage;
	dataSrcSet = fullBustImage;
	flipImageSrcSet = fullBustHoverImage;
  }

			var videoType = '';
			var flipVideoHtml = '';
			var flipVideoAlt = '';
			if (data.media.length > 1 && data.media[0].mediaContentType == 'VIDEO') {
				var mediaVideo = data.media.filter(function(e) {
				return e.mediaContentType == 'VIDEO';
				});

				if (typeof mediaVideo[0] !== 'undefined') {
				var mp4Src = mediaVideo[0]['sources'].filter(function(e) {
					return e.url.indexOf('mp4') !== -1;
				});

				flipVideoAlt = mediaVideo[0]['alt'];

				if (typeof mp4Src[0] !== 'undefined') {
					videoType = 'true';
					flipVideoHtml += '<div class="product-thumbnail__video secondary swap--visible video-on-hover not-hover-binded" data-html5-video data-alt="'+flipVideoAlt+'">';
					flipVideoHtml += '<video preload="metadata" poster="'+ Utils.optimizeImage(images[0].src, '600x') +'" playsinline="playsinline" loop="loop" muted="muted" autoplay="autoplay" class="product-video video-not-setup">';
					flipVideoHtml += '<source src="' + mp4Src[0]['url'] + '" type="video/mp4">';
					flipVideoHtml += '</video>';
					flipVideoHtml += '</div>';
				}
				}
			}

		  html += '<a href="{{itemUrl}}" class="boost-pfs-filter-product-item-image-link" ';
		  html += `data-image-default="${defaultImage}" data-image-default-hover="${hoverImage}" data-image-core="${coreImage}" data-image-core-hover="${coreHoverImage}" data-image-full-bust="${fullBustImage}" data-image-full-bust-hover="${fullBustHoverImage}" data-image-curve="${curveImage}" data-image-curve-hover="${curveHoverImage}" `;
		  html += 'style="padding-top:' + paddingTop + '%;">'+ flipVideoHtml;;

			html += '<img class="boost-pfs-filter-product-item-main-image lazyload Image--lazyLoad"' +
				'data-srcset="' + dataSrcSet + '" ' +
				'data-src="' + currentImage + '" ' +
				'data-widths="[' + dataWidths + ']" ' +
				'data-sizes="' + dataSizes + '" ' +
				'src="' + boostPFSImgDefaultSrc + '" ' +
				'alt="' + imgAlt + '" ';
	
			if (activeSwapImage) {
				html += 'data-video="'+videoType+'" data-img-flip-src="' + currentHoverImage + '" ' +
					'data-img-flip-srcset="' + flipImageSrcSet + '" ';
			}
			html += '/>';
		  html += '</a>';
  
		  return html;
	  }
  
	  function buildVendor(data) {
		  var html = '';
		  if (boostPFSThemeConfig.custom.hasOwnProperty('show_vendor') &&
			  boostPFSThemeConfig.custom.show_vendor == true) {
			  html = boostPFSTemplate.vendorHtml;

			  html = '<a href="/collections/'+Shopify.handleize(data.vendor)+'" class="mb-5 d-mb-5 p4 uppercase show-m">'+data.vendor+'</a>';
		  }

		  return html;
	  }
  
	  function buildPrice(data) {
		  var html = '';
		  if (boostPFSThemeConfig.custom.hasOwnProperty('show_price') &&
			  boostPFSThemeConfig.custom.show_price) {
			  html = '<div class="p2">';
			  if (onSale) {  
				if (priceVaries || data.tags.includes('lingerieset')) {
					html += '<span class="boost-pfs-filter-product-item-price-from-text">' + (boostPFSThemeConfig.label_basic.from) + ' ' + '</span>';
				}
				html += '<span class="boost-pfs-filter-product-item-sale-price mr-5 c-red">' + Utils.formatMoney(data.price_min).replace(" GBP", "")  + '</span>';
				html += '<s>' + Utils.formatMoney(data.compare_at_price_min).replace(" GBP", "")  + '</s>';
			  } else {
				  if (priceVaries || data.tags.includes('lingerieset')) {
					  html += '<span class="boost-pfs-filter-product-item-price-from-text">' + (boostPFSThemeConfig.label_basic.from) + ' ' + '</span>';
				  }
				  html += '<span class="boost-pfs-filter-product-item-regular-price">' + Utils.formatMoney(data.price_min).replace(" GBP", "") + '</span>';
			  }
			  html += '</div>';
		  }

          if(data.tags.includes('lingerieset')) {
            html = '';    
          }
        
		  return html;
	  }
  
	  function buildLabels(data) {
		  // Build Sold out label
		  var soldOutLabel = '';
		  if (boostPFSThemeConfig.custom.hasOwnProperty('show_sold_out_label') &&
			  boostPFSThemeConfig.custom.show_sold_out_label && soldOut) {
			  soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(/{{style}}/g, '');
		  }
		  // Build Sale label
		  var saleLabel = '';
		  if (boostPFSThemeConfig.custom.show_sale_label && onSale && !soldOut) {
			  saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{style}}/g, '');
		  }
		  // Build Labels
		  return soldOutLabel + saleLabel;
	  }
  
	  //-- get variant color count
	  function buildColorCount(data) {
		  var elem_html = '<p class="p2 c-grey mt-15 color-count-container hide-m"></p>';
		  const this_id = data.id;
		  if(data.template_suffix != 'bundle') {
		  for(let i=0; i<data.collections.length; i++) {
			if(data.collections[i].template_suffix == 'set') {
				const coll_handle = data.collections[i].handle;
				let curr_count = 0;

				console.log($.global_coll_count.length);

				for(let j=0; j<$.global_coll_count.length; j++) {
					if($.global_coll_count[j].coll_handle == coll_handle) {
						curr_count = $.global_coll_count[j].products_count;
					}
				}

				if(curr_count > 0) { 
					const delay_execute = setTimeout(() => {
						$('.boost-pfs-filter-product-item[data-id="'+this_id+'"]').find('.color-count-container').removeClass('hide-m').html('Available in '+curr_count+' colors');
						
						clearTimeout(this);
					}, 700);
				} else {
					$.ajax({
						url : '/collections/'+coll_handle+'?view=get-count',
						type : 'GET',
						dataType: 'json',
						success: function(result){
							const products_count = parseInt(result.collection.products_count);
	
							if(products_count > 1) {
								const coll_obj_temp = { "coll_handle": coll_handle, "products_count": products_count };
								$.global_coll_count.push(coll_obj_temp); 
	
								$('.boost-pfs-filter-product-item[data-id="'+this_id+'"]').find('.color-count-container').removeClass('hide-m').html('Available in '+products_count+' colors');
							}
						}
					});
				}
			}
		}
	}

		return elem_html;
	  }

	  // BUILD LABEL PRODUCT WITH TAGS
	  function buildTagLabels(data, showall) {
		  if (boostPFSThemeConfig.custom.show_label_by_tag) {
			  if (showall) {
				  var tagLabel = '';
				  if (data.tags) {
					  for (var i = 0; i < data.tags.length; i++) {
						  var tag = data.tags[i];
						  if (tag.indexOf("pfs:label") !== -1) {
							  var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
							  tagLabel += preTagLabel;
						  }
					  }
				  }
			  } else {
				  var tagLabel = '';
				  if (data.tags) {
					  for (var i = data.tags.length - 1; i >= 0; i--) {
						  tag = data.tags[i];
						  if (tag.indexOf("pfs:label") !== -1) {
							  var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
							  tagLabel += preTagLabel;
							  break;
						  }
					  }
				  }
			  }
			  return tagLabel;
		  } else {
			  return "";
		  }
	  }
	  // Build Quick Shop Button
	  function buildQuickShopButton(data) {
		var html = '';
			  if (!data.tags.includes('lingerieset') && !data.tags.includes('preorder') && !data.tags.includes('noquickshop')) {
				  html = '<div class="quick-shop bg-pink width-100 tc p4 spacing-2 uppercase hide-m show-d  pointer" data-product-handle="'+data.handle+'">Quick Shop</div>';
			  }  
			  return html;
		}
	  // Build Color Swatches
	  function buildColorSwatches(data) {
		  var colorSwatchesHtml = '',
			  filterSwatchTitle = 'Color',
			  optionName = 'color',
			  swatchArr = [],
			  countSwatch = 0,
			  swatchValues = [],
			  swatchLimit = 4;
  
		  var dataImgSize = '360',
			  bgSize = '50x',
			  dataImgSrc = Utils.getFeaturedImage(data.images_info, dataImgSize + 'x'),
			  swatchName = '#ffffff',
			  bgImageSrc = '',
			  viewMoreLabel = 'More ' + filterSwatchTitle;
  
		  if (boostPFSThemeConfig.custom.hasOwnProperty('display_item_swatch') && boostPFSThemeConfig.custom.display_item_swatch == true) {
			  if (typeof data.options_with_values != 'undefined' && data.options_with_values.length > 0) {
				  swatchArr = data.options_with_values.filter(function(option) {
					  return option.name == optionName;
				  });
				  if (swatchArr.length > 0) {
					  countSwatch = swatchArr[0].values.length;
  
					  if (swatchLimit > countSwatch) {
						  swatchLimit = countSwatch;
					  }
					  swatchValues = swatchArr[0].values;
  
					  colorSwatchesHtml += '<ul class="boost-pfs-filter-item-swatch">';
  
					  for (var sIndex = 0; sIndex < swatchLimit; sIndex++) {
						  swatchName = swatchValues[sIndex].title;
						  sImageIndex = swatchValues[sIndex].image || '';
						  if (sImageIndex != '') {
							  dataImgSrc = Utils.optimizeImage(data.images[sImageIndex], dataImgSize + 'x') + ' ' + dataImgSize + 'w';
						  }
  
  
						  if (boostPFSThemeConfig.custom.hasOwnProperty('swatch_color_display_type')) {
							  switch (boostPFSThemeConfig.custom.swatch_color_display_type) {
								  case 'swatch_color_display_type_image_color':
									  bgImageSrc = boostPFSAppConfig.general.file_url.replace(/\?/, Utils.slugify(filterSwatchTitle).replace(/\-/g, '_') + '-' + Utils.slugify(swatchName) + '.png?v=');
									  break;
								  case 'swatch_color_display_type_image_product':
									  bgImageSrc = Utils.getFeaturedImage(data.images_info, bgSize);
									  if (sImageIndex != '') {
										  bgImageSrc = Utils.optimizeImage(data.images[sImageIndex], bgSize);
									  }
									  break;
								  default:
									  bgImageSrc = '';
							  }
						  }
  
						  colorSwatchesHtml += '<li>';
						  colorSwatchesHtml += '<div class="boost-pfs-product-item-tooltip">' + swatchName + '</div>';
						  colorSwatchesHtml += '<span tabindex="0" aria-label="' + swatchName + '" ' +
							  'style="background-color: ' + swatchName + '; ';
						  if (bgImageSrc != '') {
							  colorSwatchesHtml += 'background-image: url(' + bgImageSrc + ');" ';
						  } else {
							  colorSwatchesHtml += '" ';
						  }
						  if (dataImgSrc != '') {
							  colorSwatchesHtml += 'data-img="' + dataImgSrc + '" ';
						  }
  
						  colorSwatchesHtml += '></spa>';
						  colorSwatchesHtml += '</li>';
					  }
  
					  if (countSwatch > swatchLimit) {
						  colorSwatchesHtml += '<li class="boost-pfs-filter-item-swatch-more">';
						  colorSwatchesHtml += '<a href="{{itemUrl}}" title="' + viewMoreLabel + '">+' + (countSwatch - swatchLimit) + '</a>';
						  colorSwatchesHtml += '</li>';
					  }
  
					  colorSwatchesHtml += '</ul>';
				  }
			  }
		  }
		  return colorSwatchesHtml;
	  }
  
	  // Build Color Swatches
	  function eventColorSwatches(event) {
		  jQ('.boost-pfs-filter-item-swatch li span').each(function() {
			  var img = jQ(this).parents('.boost-pfs-filter-product-item-inner').find('.boost-pfs-filter-product-item-main-image');
			  if (event == 'hover') {
				  jQ(this).hover(function() {
					  var newImage = jQ(this).data('img');
					  img.attr('srcset', newImage);
				  });
			  }
			  if (event == 'click') {
				  jQ(this).click(function() {
					  var newImage = jQ(this).data('img');
					  img.attr('srcset', newImage);
				  });
			  }
			  jQ(this).focus(function() {
				  if (jQ('body').hasClass('boost-pfs-ada')) {
					  var newImage = jQ(this).data('img');
					  img.attr('srcset', newImage);
				  }
			  });
		  });
	  }
  
	  function buildReview(data) {
		  var html = '';
		  if (boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
			  boostPFSThemeConfig.custom.show_product_review == true) {
			  html = '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>';
		  }
		  return html;
	  }
  
	  function buildActiveSwapClass(data) {
		  if (!Utils.isMobile() && images.length > 1 &&
			  boostPFSThemeConfig.custom.hasOwnProperty('active_image_swap') &&
			  boostPFSThemeConfig.custom.active_image_swap == true) {
			  return 'has-bc-swap-image';
		  }
		  return '';
	  }
  
  
  
	  /************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
	  /************************** BUILD TOOLBAR **************************/
	  // Build Pagination
	  ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		  if (!totalProduct) totalProduct = this.totalProduct;
		  // Get page info
		  var currentPage = parseInt(Globals.queryParams.page);
		  var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
		  // If it has only one page, clear Pagination
		  if (totalPage <= 1) {
			  return '';
		  }
  
		  var paginationHtml = boostPFSTemplate.paginateHtml;
		  // Build Previous
		  var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
		  previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		  paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
		  // Build Next
		  var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
		  nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		  paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
		  // Create page items array
		  var beforeCurrentPageArr = [];
		  for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			  beforeCurrentPageArr.unshift(iBefore);
		  }
		  if (currentPage - 4 > 0) {
			  beforeCurrentPageArr.unshift('...');
		  }
		  if (currentPage - 4 >= 0) {
			  beforeCurrentPageArr.unshift(1);
		  }
		  beforeCurrentPageArr.push(currentPage);
		  var afterCurrentPageArr = [];
		  for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			  afterCurrentPageArr.push(iAfter);
		  }
		  if (currentPage + 3 < totalPage) {
			  afterCurrentPageArr.push('...');
		  }
		  if (currentPage + 3 <= totalPage) {
			  afterCurrentPageArr.push(totalPage);
		  }
		  // Build page items
		  var pageItemsHtml = '';
		  var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		  for (var iPage = 0; iPage < pageArr.length; iPage++) {
			  if (pageArr[iPage] == '...') {
				  pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
			  } else {
				  pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
			  }
			  pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			  pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
		  }
		  paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
		  return paginationHtml;
	  };

	  //-- pagination after render
	  ProductPaginationInfinite.prototype.afterRender = function(data) {
		  // Get page info
		  var currentPage = parseInt(Globals.queryParams.page);
		  var totalPage = Math.ceil(this.totalProduct / Globals.queryParams.limit);

		  if(currentPage == totalPage || totalPage == 0) {
			  $('.boost-pfs-filter-load-more-loading').addClass('is-hidden');
		  }

	  };
  
	  // Build Sorting
	  ProductSorting.prototype.compileTemplate = function() {
		  var html = '';
		  if (boostPFSThemeConfig.custom.show_sorting && boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			  var sortingArr = Utils.getSortingList();
			  if (sortingArr) {
				  var paramSort = Globals.queryParams.sort || '';
				  // Build content
				  var sortingItemsHtml = '';
				  for (var k in sortingArr) {
					  activeClass = '';
					  if (paramSort == k) {
						  activeClass = 'boost-pfs-filter-sort-item-active';
					  }
					  sortingItemsHtml += '<li><a href="#" rel="nofollow" data-sort="' + k + '" class="' + activeClass + '">' + sortingArr[k] + '</a></li>';
				  }
				  html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			  }
		  }
		  return html;
	  };
  
	  ProductSorting.prototype.render = function() {
		  jQ(Selector.topSorting).html(this.compileTemplate());
  
		  if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
			  jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
		  }
  
		  var labelSort = '';
		  var paramSort = Globals.queryParams.sort || '';
		  var sortingList = Utils.getSortingList();
		  if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
			  labelSort = sortingList[paramSort];
		  } else {
			  labelSort = Labels.sorting_heading;
		  }
  
		  jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
	  }
  
	  // Build Sorting event
	  ProductSorting.prototype.bindEvents = function() {
		  var _this = this;
		  jQ('.boost-pfs-filter-filter-dropdown a').click(function(e) {
			  e.preventDefault();
			  FilterApi.setParam('sort', jQ(this).data('sort'));
			  FilterApi.setParam('page', 1);
			  FilterApi.applyFilter('sort');
		  });
  
		  jQ(".boost-pfs-filter-custom-sorting > button").click(function() {
			  /*
			  if (!jQ('.boost-pfs-filter-filter-dropdown').is(':animated')) {
				  
			  }
			  */

			  jQ('.boost-pfs-filter-filter-dropdown').toggle().parent().toggleClass('boost-pfs-filter-sort-active');
		  });
  
		  jQ(Selector.filterTreeMobileButton).click(function() {
			  jQ('.boost-pfs-filter-top-sorting-mobile .boost-pfs-filter-filter-dropdown').hide();
		  });
	  };
	  // For Toolbar - Build Display type
	  ProductDisplayType.prototype.compileTemplate = function() {
		  var itemHtml = '<span>' + boostPFSThemeConfig.label.toolbar_viewas + '</span>';
		  if (boostPFSThemeConfig.custom.product_item_type == 'grid') {
			  itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"></span></a>';
			  itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>';
  
		  } else {
			  itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>';
			  itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"></span></a>';
  
		  }
  
  
		  itemHtml = itemHtml.replace(/{{class.productDisplayType}}/g, Class.productDisplayType);
  
		  return itemHtml;
	  };
  
	  // Build Show Limit
	  ProductLimit.prototype.compileTemplate = function() {
		  var html = '';
		  if (boostPFSThemeConfig.custom.show_limit && boostPFSTemplate.hasOwnProperty('showLimitHtml')) {
  
			  var numberList = Settings.getSettingValue('general.showLimitList');
			  if (numberList != '') {
				  // Build content
				  var showLimitItemsHtml = '';
				  var arr = numberList.split(',');
				  for (var k in sortingArr) {
					  showLimitItemsHtml += '<option value="' + arr[k].trim() + '">' + arr[k].trim() + '</option>';
				  }
				  html = boostPFSTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
			  }
		  }
		  return html;
	  };
	  // Build Breadcrumb
	  Breadcrumb.prototype.compileTemplate = function(colData) {
		  if (!colData) colData = this.collectionData;
		  var breadcrumbItemsHtml = '';
		  if (boostPFSTemplate.hasOwnProperty('breadcrumbHtml')) {
			  if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
				  var colInfo = colData.collection;
				  if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) {
					  breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemLink.replace(/{{itemLink}}/g, '/collections/' + colInfo.handle).replace(/{{itemTitle}}/g, colInfo.title);
					  breadcrumbItemsHtml += " {{breadcrumbDivider}} ";
					  breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.collectionTags[0]);
				  } else {
					  breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, colInfo.title);
				  }
			  } else {
				  breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, Settings.getSettingValue('label.defaultCollectionHeader'));
			  }
		  }
		  return breadcrumbItemsHtml
	  };
  
	  /************************** END BUILD TOOLBAR **************************/
  
	  // Add additional feature for product list, used commonly in customizing product list
	  ProductList.prototype.afterRender = function(data) {
		  if (!data) data = this.data;
  
		  // Intergrate Review Shopify
		  if (window.SPR &&
			  typeof window.SPR.initDomEls == 'function' &&
			  typeof window.SPR.loadBadges == 'function' &&
			  boostPFSThemeConfig.custom.show_product_review) {
			  window.SPR.initDomEls();
			  window.SPR.loadBadges();
		  }

		  const delay_execute = setTimeout(() => {
			  if(typeof iwishCheckColl === 'function') {
				iwishCheckColl();
			  }

			clearTimeout(this);
		  }, 900);

		  $(document).find('.cta-blocks-container .boost-pfs-filter-product-item').each(function(){
			let cta_index = 8;
		
			$(`#cta-each-1`).insertBefore(`.boost-pfs-filter-products .boost-pfs-filter-product-item:nth-child(${cta_index})`);
		  });
		  //-- Add CTA - check if collection filtered
        try {
          if($(document).find('.boost-pfs-filter-refine-by').length <= 0) {
			// render cta blocks
			let total_cta = $('.cta-blocks-container .cta-each .cta-image').length;
			let counter = 0;
			
			$(document).find('.cta-blocks-container .cta-each .cta-image').each(function (index) {
			  let total_cta_exist = $(".boost-pfs-filter-wrapper .outer-wrapper").length;
			  let cta_index = parseInt($(this).parent().attr('data-index'));
			  let cta_index_place;
			
			  const maxWidthForMobile = 767;
			
			  if (window.innerWidth <= maxWidthForMobile && (cta_index + counter) % 2 === 0) {
				cta_index_place = cta_index + 1;
			  } else {
				cta_index_place = cta_index;
			  }
			
			  let elem = $(`#cta-each-${cta_index}`).parent().html();
			  if (total_cta_exist < total_cta) {
				$(elem).insertBefore(`.boost-pfs-filter-products .boost-pfs-filter-product-item:nth-child(${cta_index_place})`);
			  }
			  counter++;
			
			  var lazyLoadInstance = new LazyLoad({
				elements_selector: ".lazy"
			  });
			});
			
		  }
        } catch (error) {
          console.log(error)
        }
		  

		  	/******* watch after load more fetching data ***/
			const totalProduct = this.totalProduct;
			const toProduct = this.parent.pagination.toProduct;
			let lastPage = false;
			if(data.length < boostPFSThemeConfig.custom.products_per_page) {
				lastPage = true;
			}
			// Your code here 
			// set total product at the top of collection-template-boost-pfs-filter
			const totalProductDiv = $('.total-product-counter')
			totalProductDiv.html(totalProduct + ' products');
			totalProductDiv.attr('data-total', totalProduct);
			if(lastPage) {
				$('#collection-banner-container').removeClass('hide-m');
			} else {
				setTimeout(() => {
				const searchParams = new URLSearchParams(window.location.search);
				const currentPage = searchParams.get('page') ?? 0;
						const remainingItems = calculateRemainingProducts(totalProduct, boostPFSThemeConfig.custom.products_per_page, currentPage);
				const remainingText = (remainingItems - boostPFSThemeConfig.custom.products_per_page) < boostPFSThemeConfig.custom.products_per_page ? 'Load Last Products': `LOAD ${boostPFSThemeConfig.custom.products_per_page} MORE`;
					$('.boost-pfs-filter-load-more-button').html(remainingText);
				}, 1000);
			}
		/******* END watch after load more fetching data ***/
	  };
	  	function calculateRemainingProducts(totalProducts, productsPerPage, pageNumber) {
			var totalPages = Math.ceil(totalProducts / productsPerPage);
			var productsOnPreviousPages = (pageNumber - 1) * productsPerPage;
			var remainingProducts = totalProducts - productsOnPreviousPages;0
			remainingProducts = Math.max(0, remainingProducts);
			return remainingProducts;
		}
  
	  // Build additional elements
	  Filter.prototype.afterRender = function(data) {
		  if (!data) data = this.data;
  
		  var totalProduct = data.total_product + '<span> ' + boostPFSThemeConfig.label.items_with_count_other + '</span>';
		  if (data.total_product == 1) {
			  totalProduct = data.total_product + '<span> ' + boostPFSThemeConfig.label.items_with_count_one + '</span>';
		  }
		  jQ('.boost-pfs-filter-total-product').html(totalProduct);
  
		  jQ('body').find('.boost-pfs-filter-skeleton-button').remove();
  
		  // Prevent double tap on iOS
		  var isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
		  if (isiOS) {
			  Utils.isMobile() && jQ(".boost-pfs-filter-product-item").find("a").on("touchstart", function() {
				  isScrolling = !1
			  }).on("touchmove", function() {
				  isScrolling = !0
			  }).on("touchend", function() {
				  isScrolling || (window.location = jQ(this).attr("href"))
			  });
		  }
  
		  // Build Image Swap. Put this function here to impprove the pagespeed.
		  swapImage(data);
  
		  // Build Equal Height
		  if (Globals.queryParams.display !== 'list') {
			  equalHeight(data);
		  };
  
		  jQ(window).resize(function() {
			  if (Globals.queryParams.display !== 'list') {
				  equalHeight(data);
			  }
		  });
  
		  // Build Event Color Swatch
		  if (boostPFSThemeConfig.custom.swatch_color_event_change_image != 'none') {
			  eventColorSwatches(boostPFSThemeConfig.custom.swatch_color_event_change_image);
		  }
  
		  if (typeof boostRemoveImageLoadingAnimation == 'function') {
			  boostRemoveImageLoadingAnimation(jQ(Selector.products).find('[data-boost-image-loading-animation]'));
		  }

		  //-- init custom scrollbar
			$('.boost-pfs-filter-option-content-inner').each(function(){
				new SimpleBar($(this)[0]);
			});
	  };
  
	  ProductListPlaceholder.prototype.render = function() {
		  // Set limit number for product skeleton
		  var placeholderLimit = this.settings.productsPerRow || this.settings.placeholderProductPerRow;
		  // Build placeholder items
		  var placeholderItem = this.compileTemplate();
		  this.$element = [];
		  for (var i = 0; i < placeholderLimit; i++) {
			  this.$element.push(jQ(placeholderItem));
		  }
		  // Show placeholder before send filter request OR hide it after get filter data
		  if (!this.isFetchedProductData) {
			  this.setShow();
		  } else {
			  this.setHide();
		  }
	  }
  
	  ProductListPlaceholder.prototype.compileTemplateExtra = function() {
		  var display = Globals.queryParams.display
		  switch (display) {
			  case 'list':
				  //Todo: Build placeholder for List mode
				  var template = boostPFSTemplate.productListPlaceholderHtml;
				  var imgRatioSetting = parseFloat(this.settings.placeholderImageRatio);
				  var imgRatio = imgRatioSetting > 0 ? imgRatioSetting : 1.4; // It mean w1:h1.4
				  /**
				   * Set product class for product skeleton (to set column, style, etc.)
				   * - If had defined product_grid_class in boostPFSThemeConfig => use this config ELSE use our setting
				   */
				  break;
		  }
		  return template
			  .replace(/{{class.filterProductSkeleton}}/g, Class.filterProductSkeleton)
			  .replace(/{{class.filterSkeleton}}/g, Class.filterSkeleton)
			  .replace(/{{class.filterSkeletonText}}/g, Class.filterSkeletonText)
			  .replace(/{{paddingTop}}/g, imgRatio * 100)
	  }
  
	  /* Prevent conflict with theme vendor js */
	  Array.prototype.insert = function(a, b) {}
  
	  /* Math qual Height */
	  function equalHeight(data) {
		  var equal_i = -1;
		  var equal_els = [];
		  var equal_element = null;
  
		  // Equal Height Title
		  jQ('.boost-pfs-filter-product-item').each(function(i, element) {
  
			  var offsetTop = jQ(element).offset().top;
			  if (!equal_element || equal_element.offset().top !== offsetTop) {
				  equal_element = jQ(element);
				  equal_i++;
			  }
  
			  if (!equal_els[equal_i]) {
				  equal_els[equal_i] = [];
			  }
			  equal_els[equal_i].push(element);
		  });
  
		  for (var i = 0; i < equal_els.length; i++) {
			  var max = 0;
			  var maxRatio = 0;
			  var iLength = equal_els[i].length;
  
			  for (var j = 0; j < equal_els[i].length; j++) {
				  var item = equal_els[i][j];
				  var height = jQ(item).find('.boost-pfs-filter-product-bottom-inner').height();
				  max = Math.max(max, height);
  
			  }
  
			  jQ(equal_els[i]).find('.boost-pfs-filter-product-bottom-inner').css({ 'min-height': max });
  
		  }
  
		  var equal_height = boostPFSFilterConfig.general.equal_height;
  
		  if (equal_height != 'false') {
			  var cropImagePosition = boostPFSFilterConfig.general.cropImagePossitionEqualHeight;
  
			  var widthImage = jQ('.boost-pfs-filter-product-item').width();
			  var indexData = 0;
  
			  // For Ratio
			  if (equal_height != 'false' && equal_height != 'auto') {
				  var heightImage = 0;
				  var widthImage = jQ('.boost-pfs-filter-product-item').width();
				  if (equal_height != 'false' && equal_height != 'auto') {
					  var ratioWidthHeight = boostPFSThemeConfig.custom.equal_height;
				  } else {
					  var ratioWidthHeight = '';
				  }
  
				  var ratioWidthHeightOther = boostPFSThemeConfig.custom.ratio_width_height_other;
				  if (ratioWidthHeightOther == '' && ratioWidthHeight == '') {
					  return null;
				  } else {
					  if (ratioWidthHeightOther == '') {
						  ratioWidthHeight = ratioWidthHeight.split(':');
						  ratioWidthHeight = parseInt(ratioWidthHeight[1]) / parseInt(ratioWidthHeight[0]);
						  heightImage = widthImage * ratioWidthHeight;
					  } else if (ratioWidthHeightOther != '') {
						  ratioWidthHeightOther = ratioWidthHeightOther.split(':');
						  ratioWidthHeightOther = parseInt(ratioWidthHeightOther[1]) / parseInt(ratioWidthHeightOther[0]);
						  heightImage = widthImage * ratioWidthHeightOther;
					  }
				  }
				  jQ('.boost-pfs-filter-product-item-image-link').css({ 'padding-top': heightImage + 'px' }).addClass('boost-pfs-filter-crop-image-position-' + cropImagePosition);;
  
			  }
		  }
	  }
  
	  // Swap Image
	  function swapImage(data) {
		  if (!Utils.isMobile()) {
			  if (boostPFSThemeConfig.custom.hasOwnProperty('active_image_swap') &&
				  boostPFSThemeConfig.custom.active_image_swap == true) {
				  var dataSrcSetFlipImg = '',
					  dataSrcFlipImg = '',
					  flipImageAlt = '',
					  dataSizes = 'auto',
					  dataWidths = '',
					  html = '';
  
				  jQ(".boost-pfs-filter-product-item").each(function() {
					  var productItemSelector = jQ(this);
					  var imgSelector = productItemSelector.find('.boost-pfs-filter-product-item-main-image');
  
					  if (typeof imgSelector.data('img-flip-src') != 'undefined' &&
						  imgSelector.data('img-flip-src') != '') {
						  dataSrcFlipImg = imgSelector.data('img-flip-src');
						  dataSrcSetFlipImg = imgSelector.data('img-flip-srcset');
						  flipImageAlt = imgSelector.attr('alt');
						  dataWidths = imgSelector.data('widths');
						  html = '<img class="boost-pfs-filter-product-item-flip-image lazyload Image--lazyLoad"' +
							  'data-srcset="' + dataSrcSetFlipImg + '" ' +
							  'data-src="' + dataSrcFlipImg + '" ' +
							  'data-widths="[' + dataWidths + ']" ' +
							  'data-sizes="' + dataSizes + '" ' +
							  'src="' + boostPFSImgDefaultSrc + '" ' +
							  'alt="' + flipImageAlt + '" />';
  
						  productItemSelector.find('.boost-pfs-filter-product-item-image-link').prepend(html);
					  }
  
				  });
			  }
		  }
	  }
  
	  // Build Placeholder for the first load
	  function boostRemoveImageLoadingAnimation($selector) {
		  if ($selector.length) {
			  $selector.removeAttr('data-boost-image-loading-animation');
		  }
	  }
  
	  // Function after filter
	  FilterResult.prototype.afterRender = function() {
			var data = this.data;	
			if(data.event_type == 'clearAll' || data.total_product <= 6) {
				// window.scrollTo({top: 200, behavior: 'smooth'});
			}

		  if($('.size-group-name').length) {
			  const sizeGroup = $('.size-group-name').first().attr("data-value");
			  if(sizeGroup != '') {
				  updateProductCollectionImage(sizeGroup);
			  }
		  }
	  }
  })();